import React, { useContext, useState } from 'react'
import css from "./restore.module.scss"
import { AuthContext } from "../../../context/auth";
import { Input } from "../../Input"
import { resetPasswordApi, checkEmailExist } from '../../../api';

export const RestoreModal = () => {
  const { setRestoreModal, setChangePasswordRestoreModal, setIsLoading, setNotification } = useContext(AuthContext)
  const [type, setType] = useState('restore')
  const [email, setEmail] = useState('')


  const resetPassword = () => {
    setIsLoading(true)
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      checkEmailExist(email).then((res) => {
        if (res?.data?.exists) {
          resetPasswordApi({ email: email }).then((res) => {
            setIsLoading(false)
            setType('check-email')
          }).catch((err) => {
            setIsLoading(false)
            setNotification({
              type: 'red',
              message: 'Something went wrong, please try again!'
            })
          })
        } else {
          setIsLoading(false)
          setNotification({
            type: 'red',
            message: 'No user found with this email address'
          })
        }
      }).catch((err) => {
        setIsLoading(false)
        setNotification({
          type: 'red',
          message: 'Something went wrong, please try again!'
        })
      })
    } else {
      setIsLoading(false)
      setNotification({
        type: 'red',
        message: 'Please enter a valid Email Address'
      })
    }
  }

  const resend = () => {
    setIsLoading(true)
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      resetPasswordApi({ email: email }).then((res) => {
        setIsLoading(false)
      }).catch((err) => {
        setIsLoading(false)
        setNotification({
          type: 'red',
          message: 'Something went wrong, please try again!'
        })
      })
    } else {
      setIsLoading(false)
      setNotification({
        type: 'red',
        message: 'Please enter a valid Email Address'
      })
    }
  }

  return (
    <div className={css.modalWrapper}>
      <div className={css.modalContent}>
        <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
          <span className={css.icon}>
            <i class="fal fa-envelope"></i>
          </span>
          <span className={css.closeIcon} onClick={() => setRestoreModal(false)}><i className="fal fa-times"></i></span>
        </div>
        {type === 'restore' ? <>
          <h2>Restore Password </h2>
          <p>Don’t worry, we’ll send you a restore link
            to your email address </p>
          <div style={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px', marginTop: '20px' }}>
            <h4>Enter your email address below</h4>
            <Input placeholder="Enter Email Address" value={email} onChange={(e) => setEmail(e.target.value)} style={{ textAlign: 'center' }} />
          </div>
          <button className={`btn ${css.btn}`} disabled={!email} onClick={() => {
            resetPassword()
          }}>Continue</button>
          <button className={`btn ${css.transparentBtn}`} onClick={() => {
            setRestoreModal(false)
          }}>Cancel</button>
        </>
          : type === 'check-email' &&
          <>
            <h2>Check Email </h2>
            <p>We sent a link to reset your password to <span style={{ fontWeight: 500 }}>{email}</span>.</p>
            <div style={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px', marginTop: '20px' }}>
              <p>Didn't get it? <span className={css.link}
                onClick={() => {
                  resend()
                }}
              >Resend</span></p>
            </div>
            <button className={`btn ${css.btn}`} onClick={() => {
              setRestoreModal(false)
              setType('restore')
            }}>Okay</button>
          </>
        }
      </div>
    </div>
  )
}